export default {
  'waitlistSettings.title': '排队',
  'waitlistSettings.section.enable.google.waitlist': 'Google在线排队',
  'waitlistSettings.section.enable.google.waitlist.desc': '将于次日5am～7am生效',
  'waitlistSettings.section.businesshour': '在线排队营业时间',
  'waitlistSettings.section.tablequeue': '桌型设置',
  'waitlistSettings.section.businesshour.lunch': '午餐',
  'waitlistSettings.section.businesshour.dinner': '晚餐',
  'waitlistSettings.section.businesshour.lunch.error': '请设置午餐可排队时间范围',
  'waitlistSettings.section.businesshour.dinner.error': '请设置晚餐可排队时间范围',
  'waitlistSettings.section.businesshour.all.error': '请设置午餐/晚餐可排队时间范围',
  'waitlistSettings.section.businesshour.all.overlap.error': '设置的午餐/晚餐时间范围有重叠',
  'waitlistSettings.section.tableQueue.action.add': '新增桌型',
  'waitlistSettings.section.tableQueue.field.capacity': '容纳人数',
  'waitlistSettings.section.tableQueue.field.tablename': '桌型名',
  'waitlistSettings.section.tableQueue.field.tableforeignName': '桌型中文名',
  'waitlistSettings.section.tableQueue.field.queuePrefix': '排队前缀',
  'waitlistSettings.section.tableQueue.field.queue.estimateTime': '预计翻台时间',
  'waitlistSettings.section.tableQueue.field.queue.estimateTime.suffix': '分钟',
  'waitlistSettings.section.tableQueue.field.note': '备注 - 英',
  'waitlistSettings.section.tableQueue.field.note.foreign': '备注 - 中',
  'waitlistSettings.section.tableQueue.field.note.foreign.limit': '中文65个字符上限',
  'waitlistSettings.section.tableQueue.field.note.limit': '英文150个字符上限',

  'waitlistSettings.section.tableQueue.field.tablename.required': '桌子名必填',
  'waitlistSettings.section.tableQueue.field.tableforeignName.required': '桌子中文名必填',
  'waitlistSettings.section.tableQueue.field.queuePrefix.required': '排队序号前缀必填',
  'waitlistSettings.section.tableQueue.field.queue.estimateTime.required': '预计就餐时长必填',
  'waitlistSettings.section.tableQueue.field.capacity.min.required': '桌子最少可就餐人数必填',
  'waitlistSettings.section.tableQueue.field.capacity.max.required': '桌子最大可就餐人数必填',
  'waitlistSettings.section.tableQueue.field.capacity.range.error': '最少可就餐人数不能大于最大可就餐人数',

  'waitlistSettings.section.tableQueue.field.note.placeholder': '请输入英文备注',
  'waitlistSettings.section.tableQueue.field.note.foreign.placeholder': '请输入中文备注',
  'waitlistSettings.section.tableQueue.table.name.duplicated.error': '有重复的桌子名:{tableNames}',
  'waitlistSettings.section.tableQueue.table.foreignName.duplicated.error': '有重复的桌子中文名:{tableForeignNames}',
  'waitlistSettings.section.tableQueue.prefix.duplicated.error': '有重复的排队前缀:{duplicatePrefix}',
  'waitlistSettings.section.tableQueue.table.capacity.overlap.error': '桌子可就餐人数有重叠:{overlapCapacity}',
  'waitlistSettings.section.': '在线排队营业时间',

  'waitlistSettings.section.table.seating': '餐厅入座偏好',
  'waitlistSettings.section.table.seating.notneed.selectTable': '仅标记入座(默认，不需要选择桌子)',
  'waitlistSettings.section.table.seating.need.selectTable': '选择桌子并用户入座（只记录桌号，不会开桌）',

  'waitlistSettings.enable.google.error': '请先设置允许在线排队的桌型',
  'waitlistSettings.enable.google.error.igot.button': '我知道了',
};
